import type { BarSeriesOption } from 'echarts/charts';

import type { SingleBarBreakdownDatum } from './types';

const CORNER_RADIUS = 6;

const getBorderRadius = (index: number, total: number): [number, number, number, number] => {
  if (total === 1) return [CORNER_RADIUS, CORNER_RADIUS, CORNER_RADIUS, CORNER_RADIUS];
  if (index === 0) return [CORNER_RADIUS, 0, 0, CORNER_RADIUS];
  if (index === total - 1) return [0, CORNER_RADIUS, CORNER_RADIUS, 0];
  return [0, 0, 0, 0];
};

export const buildSingleBarBreakdownSeries = (
  data: SingleBarBreakdownDatum[],
  backgroundColor: string,
): BarSeriesOption[] =>
  data.map((datum, index) => ({
    type: 'bar',
    stack: 'breakdown',
    data: [datum.value],
    barWidth: '100%',
    itemStyle: {
      color: datum.color,
      borderColor: backgroundColor,
      borderWidth: 1,
      borderRadius: getBorderRadius(index, data.length),
    },
    emphasis: { disabled: true },
  }));
